document.addEventListener('DOMContentLoaded', function() {

  // === Feel Fabulous – unified angle logic ===
  var angle = new URLSearchParams(window.location.search).get('a') || '';
  window.thumbClicked = false;

  if (!angle) {
    ['feel-fab-mobile-text', 'feel-fab-desktop-text'].forEach(function(id) {
      var el = document.getElementById(id);
      if (el) { el.classList.remove('feel-fab-hidden'); }
    });
  }

  if (!window.feelFabLoaded) {
    window.feelFabLoaded = true;

    window.addEventListener('scroll', function() {
      var ov = document.querySelector('.feel-fab-overlay');
      if (!ov) return;
      var container = document.querySelector('.wl-hero-main-image');
      if (!container) return;
      var header = document.querySelector('header') || document.querySelector('.header-wrapper') || document.querySelector('#shopify-section-header');
      var headerHeight = header ? header.offsetHeight : 0;
      var rect = container.getBoundingClientRect();
      ov.style.visibility = rect.top < headerHeight ? 'hidden' : 'visible';
    });
  }

  window.runAngleLogic = function() {
    var overlayEl = document.getElementById('feel-fab-overlay-data');
    var staleOverlay = document.querySelector('.feel-fab-overlay');
    if (staleOverlay) {
      if (window.thumbClicked) return;
      staleOverlay.remove();
    }

    if (overlayEl) {
      var line1 = (angle ? overlayEl.getAttribute('data-line1-' + angle) : '') || 'Your skin changed.';
      var line2 = (angle ? overlayEl.getAttribute('data-line2-' + angle) : '') || 'Your routine didn\u2019t.';
      var container = document.querySelector('.wl-hero-main-image');
      if (container) {
        container.style.position = 'relative';
        container.style.overflow = 'visible';
        var isMobile = window.innerWidth <= 900;
        var overlay = document.createElement('div');
        overlay.className = 'feel-fab-overlay';
        overlay.setAttribute('style',
          'position:absolute;z-index:999;pointer-events:none;' +
(isMobile ? 'top:38px;left:20px;width:70%;text-align:left;' : 'top:12%;left:6%;width:50%;text-align:left;')
        );
        var s1 = document.createElement('span');
        s1.setAttribute('style',
         'font-family:"DM Serif Display",serif;font-size:' + (isMobile ? '1.65rem' : 'clamp(2rem,2.8vw,2.8rem)') + ';font-weight:400;color:#2B2B2B;display:block;line-height:1.05;'
        );
var line1Parts = line1.trim().split(' ');
var line1Last = line1Parts.pop();
var line1Main = line1Parts.join(' ').replace(/looks/, '<span style="font-style:italic;text-decoration:underline;text-decoration-color:#8a7a6a;text-underline-offset:4px;">looks</span>');
s1.innerHTML = line1Main + '<br>' + line1Last;
        var divider = document.createElement('span');
        divider.setAttribute('style', 'display:block;width:32px;height:1px;background:#8a7a6a;margin:6px 0;');
        var s2 = document.createElement('span');
        s2.setAttribute('style',
'font-family:"DM Sans",sans-serif;font-size:' + (isMobile ? '1.35rem' : 'clamp(1.6rem,2.2vw,2rem)') + ';font-weight:400;color:#2B2B2B;display:block;line-height:1.05;margin-top:4px;'
        );
        var line2Parts = line2.trim().split(' ');
var line2Last = line2Parts.pop();
s2.innerHTML = line2Parts.join(' ') + '<br>' + line2Last;

        overlay.appendChild(s1);
        overlay.appendChild(divider);
        overlay.appendChild(s2);
        container.appendChild(overlay);
      }
    }

    if (angle) {
      var textarea = document.querySelector('.feel-fab-angle-data[data-angle="' + angle + '"]');
      if (textarea) {
        var copy = textarea.value.trim();
        if (copy) {
          var lines = copy.split('\n').filter(function(l) { return l.trim(); });
          ['feel-fab-mobile-text', 'feel-fab-desktop-text'].forEach(function(id) {
            var el = document.getElementById(id);
            if (!el) return;
            el.innerHTML = '';
            lines.forEach(function(line, index) {
              var p = document.createElement('p');
              if (index === lines.length - 1) {
                var strong = document.createElement('strong');
                strong.textContent = line.trim();
                p.appendChild(strong);
              } else {
                p.textContent = line.trim();
              }
              el.appendChild(p);
            });
            el.classList.remove('feel-fab-hidden');
          });
        }
      }
    }

    var pullquote = document.querySelector('.wl-hero-pullquote');
    if (pullquote && overlayEl && angle) {
      var testimonial = overlayEl.getAttribute('data-testimonial-' + angle);
      var author = overlayEl.getAttribute('data-testimonial-author-' + angle);
      if (testimonial && testimonial.trim()) {
        pullquote.childNodes[0].textContent = '\u201c' + testimonial + '\u201d';
        var span = pullquote.querySelector('span');
        if (span && author) span.textContent = '\u2014 ' + author;
      } else {
        pullquote.style.display = 'none';
      }
    }
    if (pullquote) pullquote.style.display = 'block';

    var badge = document.querySelector('.wl-hero-badge');
    if (badge) {
      badge.textContent = 'DESIGNED FOR MIDLIFE SKIN';
      badge.style.display = 'block';
    }

    var desc = document.getElementById('wl-hero-desc');
    if (desc && overlayEl && angle) {
      var descText = overlayEl.getAttribute('data-desc-' + angle);
      if (descText && descText.trim()) {
        var parts = descText.split('||');
        var html = '';
        parts.forEach(function(part) {
          if (part.trim()) html += '<p class="wl-hero-desc-intro">' + part.trim() + '</p>';
        });
        desc.innerHTML = html;
      }
    }
    if (desc) desc.style.display = 'block';
  };

  window.runAngleLogic();
  setTimeout(window.runAngleLogic, 800);
  setTimeout(function() { if (!window.thumbClicked) window.runAngleLogic(); }, 2000);

});
